<script>
import { formatRenotificationDate, renotificationState } from '@/utils/faqRenotification'

export default {
  computed: {
    state () {
      return renotificationState(this.params.data)
    },
    lastRenotifiedAt () {
      return formatRenotificationDate(this.state.lastAt)
    }
  }
}
</script>

<template>
  <div class="renotification-tooltip">
    <p>Nombre de renotification total : {{ state.count }}</p>
    <p>Date de dernière renotification : {{ lastRenotifiedAt }}</p>
    <p v-if="state.blockedReason" class="renotification-tooltip__reason">{{ state.blockedReason }}</p>
  </div>
</template>

<style lang="scss" scoped>
.renotification-tooltip { background: #111827; border-radius: 6px; box-shadow: 0 8px 20px rgba(15, 23, 42, .2); color: #fff; font-size: 12px; line-height: 1.5; padding: 8px 10px; }
.renotification-tooltip__reason { border-top: 1px solid rgba(255, 255, 255, .2); color: #d1d5db; margin-top: 6px; padding-top: 6px; }
</style>
